/* @ngInject */
const data = () => {
  const self = {}

  return self
}

export default data



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/contact/services/data.service.js